import React, { Component } from 'react'
import { injectIntl, FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import { Input } from 'src/components/Form'
import Button from 'src/components/Button/Button'
import { Box, Text } from '@chakra-ui/react'
import { Form, Field } from 'react-final-form'
import { Layout, Container, PageTitle } from 'src/components/Layout'
import Disclaimer from 'src/modals/Disclaimer'
import intlMessages from '../../translations'
import ThankYou from 'src/modals/ThankYou/index'

class AddDriver extends Component {
  state = {
    driver: null,
    error: false,
    confirmed: false,
    showDisclaimer: false,
  }

  componentDidUpdate(prevProps) {
    const { successful, submitting } = this.props

    if (!submitting && prevProps.submitting && successful) {
      this.setState({
        showDisclaimer: false,
        confirmed: true,
      })
    }

    if (!submitting && prevProps.submitting && !successful) {
      this.setState({
        showDisclaimer: false,
        error: true,
      })
    }
  }

  handleBack = () => {
    const { history } = this.props
    history.push('/documents/item')
  }

  handleSubmit = values => {
    this.setState({
      driver: values,
      showDisclaimer: true,
    })
  }

  handleCloseDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
    })
  }

  handleCloseThankYouModal = () => {
    const { history } = this.props
    this.setState({
      confirmed: false,
    })
    history.push('/documents/item')
  }

  handleSubmitDisclaimer = () => {
    const { addDocumentDriver, document } = this.props
    const { driver } = this.state

    const data = {
      ...driver,
      documentId: document.id,
      documentType: document.type,
    }

    addDocumentDriver(data)
  }

  renderThankYouContent = driver => {
    const { countryIsoCode } = this.props

    if (!driver) return

    return (
      <Text>
        {countryIsoCode && countryIsoCode.toLowerCase() === 'us' ? (
          <FormattedHTMLMessage
            id='app.document.addDriver.thankYou2US'
            defaultMessage='Your request to add <br /> <b>{firstName} {lastName}</b> <br /> has been sent to your agent'
            values={{
              firstName: driver.firstName,
              lastName: driver.lastName,
            }}
          />
        ) : (
          <FormattedHTMLMessage
            id='app.document.addDriver.thankYou2'
            defaultMessage='Your request to add <br /> <b>{firstName} {lastName}</b> <br /> has been sent to your broker'
            values={{
              firstName: driver.firstName,
              lastName: driver.lastName,
            }}
          />
        )}
      </Text>
    )
  }

  renderError = () => {
    return (
      <div style={{ textAlign: 'center' }}>
        <h2>
          <FormattedMessage id='app.document.addDriver.error' defaultMessage='Error' />
        </h2>
        <p>
          <FormattedMessage
            id='app.document.addDriver.somethingWentWrong'
            defaultMessage='Something went wrong. Please try again.'
          />
        </p>
      </div>
    )
  }
  validateFormFields = values => {
    const { intl } = this.props

    const errors = {}
    if (!values.firstName) {
      errors.firstName = intl.formatMessage(intlMessages.documentAddDriverValidationFirstName)
    }

    if (!values.lastName) {
      errors.lastName = intl.formatMessage(intlMessages.documentAddDriverValidationLastName)
    }

    if (!values.driverLicense) {
      errors.driverLicense = intl.formatMessage(
        intlMessages.documentAddDriverValidationDriverLicense,
      )
    }
    return errors
  }

  renderForm = () => {
    const { intl } = this.props

    return (
      <Box>
        <Box mt={'10px'} mb={'20px'}>
          <Text variant='secondary' fontWeight={500} align={'center'} fontSize={'16px'}>
            <FormattedMessage id='app.document.addDriver.driverInfo' defaultMessage='Driver Info' />
          </Text>
        </Box>
        <Form
          onSubmit={this.handleSubmit}
          validate={this.validateFormFields}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Field
                name='firstName'
                render={({ input, meta }) => (
                  <Box mb={'20px'}>
                    <Input
                      placeholder={intl.formatMessage(intlMessages.documentAddDriverLabelFirstName)}
                      error={meta}
                      name='firstName'
                      {...input}
                    />
                  </Box>
                )}
              />
              <Field
                name='lastName'
                render={({ input, meta }) => (
                  <Box mb={'20px'}>
                    <Input
                      placeholder={intl.formatMessage(intlMessages.documentAddDriverLabelLastName)}
                      error={meta}
                      name='lastName'
                      {...input}
                    />
                  </Box>
                )}
              />
              <Field
                name='driverLicense'
                render={({ input, meta }) => (
                  <Box mb={'20px'}>
                    <Input
                      placeholder={intl.formatMessage(
                        intlMessages.documentAddDriverLabelDriverLicence,
                      )}
                      error={meta}
                      name='driverLicense'
                      {...input}
                    />
                  </Box>
                )}
              />
              <Field
                name='phone'
                render={({ input, meta }) => (
                  <Box mb={'20px'}>
                    <Input
                      placeholder={intl.formatMessage(intlMessages.documentAddDriverLabelPhone)}
                      error={meta}
                      name='phone'
                      {...input}
                    />
                  </Box>
                )}
              />
              <Field
                name='address'
                render={({ input, meta }) => (
                  <Box mb={'20px'}>
                    <Input
                      placeholder={intl.formatMessage(intlMessages.documentAddDriverLabelAddress)}
                      error={meta}
                      name='address'
                      {...input}
                    />
                  </Box>
                )}
              />
              <Button isFullWidth type='submit' size='lg'>
                <FormattedMessage id='app.document.addDriver.submit' defaultMessage='Add' />
              </Button>
            </form>
          )}
        />
      </Box>
    )
  }

  render() {
    const { submitting, intl, features } = this.props
    const { showDisclaimer, driver, error, confirmed } = this.state

    const foundedFeature = features.find(f => f.id == 'documents')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.documentsHeadline)

    return (
      <Layout>
        <PageTitle
          title={intl.formatMessage(intlMessages.documentAddDriverHeadline)}
          subtitle={title}
        />
        <Container padder className='global-centered-desktop-content'>
          {!error ? this.renderForm() : this.renderError()}
          <ThankYou
            visible={confirmed}
            onClose={this.handleCloseThankYouModal}
            renderContent={this.renderThankYouContent(driver)}
          />
          <Disclaimer
            visible={showDisclaimer}
            loading={submitting}
            handleFinish
            onClose={this.handleCloseDisclaimer}
            onSubmit={this.handleSubmitDisclaimer}
          />
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(AddDriver)
